import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
// import { NULL } from 'graphql/language/kinds';
import getNumDiasMes from '../../../functions/getnumdiasmes';

const DetalleNivel = props => {
  return (
    <option>{props.elemento.descrCategOST}</option>
  )
};

const ListaCateg = ({handleLista, list}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrCategOST" id="miListaCateg" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const DetalleNivelTipo = props => {
  return (
    <option dato1={props.elemento.codigoTipoOS} dato2={props.elemento.descrTipoOS} value={props.elemento._id}>{props.elemento.codigoTipoOS} ={">"} {props.elemento.descrTipoOS}</option>
  )
};

const ListaTipo = ({styles, handleLista, list, estado}) => {
    let nuevoList = []
    if(estado==='NUEVO'){
      nuevoList = list.filter(elemento => (elemento.paraCliNuevo==='SI'&&elemento.estadoCrearOS==='NUEVO')||elemento.estadoCrearOS==='CUALQUIERA');
    }else{
      switch(estado){
        // case 'NUEVO':
        //   nuevoList = list.filter(elemento => elemento.estadoCrearOS==='NUEVO');
        //   break
        case 'ACTIVO':
          nuevoList = list.filter(elemento => elemento.estadoCrearOS==='ACTIVO'||
              elemento.estadoCrearOS==='ACTIVO, DESCONECTADO, SUSPENDIDO o RETIRADO'||elemento.estadoCrearOS==='ACTIVO, DESCONECTADO o SUSPENDIDO'||elemento.estadoCrearOS==='CUALQUIERA');
          break
        case 'DESCONECTADO':
          nuevoList = list.filter(elemento => elemento.estadoCrearOS==='DESCONECTADO, SUSPENDIDO o RETIRADO'||elemento.estadoCrearOS==='DESCONECTADO o SUSPENDIDO'||
          elemento.estadoCrearOS==='ACTIVO, DESCONECTADO, SUSPENDIDO o RETIRADO'||elemento.estadoCrearOS==='ACTIVO, DESCONECTADO o SUSPENDIDO'||elemento.estadoCrearOS==='CUALQUIERA');
          break
        case 'SUSPENDIDO':
          nuevoList = list.filter(elemento => elemento.estadoCrearOS==='DESCONECTADO, SUSPENDIDO o RETIRADO'||elemento.estadoCrearOS==='DESCONECTADO o SUSPENDIDO'||
            elemento.estadoCrearOS==='ACTIVO, DESCONECTADO, SUSPENDIDO o RETIRADO'||elemento.estadoCrearOS==='ACTIVO, DESCONECTADO o SUSPENDIDO'||elemento.estadoCrearOS==='CUALQUIERA');
          break
        case 'RETIRADO':
          nuevoList = list.filter(elemento => elemento.estadoCrearOS==='DESCONECTADO, SUSPENDIDO o RETIRADO'||elemento.estadoCrearOS==='RETIRADO'||
            elemento.estadoCrearOS==='ACTIVO, DESCONECTADO, SUSPENDIDO o RETIRADO'||elemento.estadoCrearOS==='CUALQUIERA');
          break
        default:
          nuevoList = []
      }
    }
    const NivelDetalleTipo = nuevoList.map((elemento, _id) => <DetalleNivelTipo elemento={elemento} key={elemento._id} />);
    return(
      <div>
        <select style={styles.input} className="ui simple selection dropdown fluid" name="tipoos" id="miLista" onChange={handleLista}>
          <option style={styles.input} value="">Seleccionar...</option>
          {NivelDetalleTipo}
        </select>
      </div>
    )
};

//

const DetListInf = ({elemento, handleChange}) => {
    return(
      <tr className=''>
        <td className='collapsing'>
          <div className='ui fitted slider checkbox'>
            <input type='checkbox' name='estadoInf' id={elemento._id} checked={elemento.estadoLis} onChange={(ev)=>handleChange(ev, elemento)}/>
            <label />
          </div>
        </td>
        <td className=''>{elemento.codigoTipoDoc}</td>
        <td className=''>{elemento.numeroDocum}</td>
        <td className=''>{elemento.descrRecurso}</td>
        <td className=''>{elemento.descrTipoRec}</td>
      </tr>
    )
  };
  
  const ListaInf = ({list, handleChange}) => {
    const nivelDetInf = list.map((elemento, _id) => <DetListInf elemento={elemento} handleChange={handleChange} key={elemento._id}/>);
    return(
      <tbody className=''>
        {nivelDetInf}
      </tbody>
    )
  };

  const DetListSup = ({elemento, handleChange}) => {
    return(
      <tr className=''>
        <td className='collapsing'>
          <div className='ui fitted slider checkbox'>
            <input type='checkbox' name='estadoSup' id={elemento._id} checked={elemento.estadoLis} onChange={(ev)=>handleChange(ev, elemento)}/>
            <label />
          </div>
        </td>
        <td className=''>{elemento.codigoTipoDoc}</td>
        <td className=''>{elemento.numeroDocum}</td>
        <td className=''>{elemento.descrRecurso}</td>
        <td className=''>{elemento.descrTipoRec}</td>
      </tr>
    )
  };
  
  const ListaSup = ({list, handleChange}) => {
    const nivelDetSup = list.map((elemento, _id) => <DetListSup elemento={elemento} handleChange={handleChange} key={elemento._id}/>);
    return(
      <tbody className=''>
        {nivelDetSup}
      </tbody>
    )
  };
//
// let paraHoraHoy = new Date()
// let horaSolic = ((paraHoraHoy.getHours())<10?'0'+(paraHoraHoy.getHours()):(paraHoraHoy.getHours()))+":"+((paraHoraHoy.getMinutes())<10?'0'+(paraHoraHoy.getMinutes()):(paraHoraHoy.getMinutes()));
//se trae horaSolic como props porque dejandolo aqui el valor no cambia hasta que salga y vuelva a entrar
//a la app
class AddOS2 extends React.Component {
  state={
      listInf: this.props.lisInf,
      listSup: this.props.lisSup,
      errors: this.props.errors,
      fechaEjec: "",
      fechaFra: "",
      horaSolic: this.props.horaSolic,
      checkNoFactOsAb: false
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
        return a[campo] > b[campo];
    });
  }

  handleRefresh = () => {
    let arraySup=this.state.listSup
    let arrayInf=this.state.listInf

    arrayInf.forEach((elemento, _id) => {
      if(elemento.estadoLis===true){
        arraySup.push({_id: elemento._id, codigoTipoDoc: elemento.codigoTipoDoc,
          numeroDocum: elemento.numeroDocum, descrRecurso: elemento.descrRecurso, _idTipoRec: elemento._idTipoRec,
          descrTipoRec: elemento.descrTipoRec, areaAprovech: elemento.areaAprovech,
          estadoLis: true});
      }
    })

    let arrayInf1 = arrayInf.filter(item => item.estadoLis===true);
    arrayInf1.forEach((elemento1, _id) => {
      arrayInf.forEach((elemento, _id) => {
        if(elemento.estadoLis===true && elemento1._id===elemento._id){
          const indexLis = arrayInf.findIndex( servicio => servicio._id === elemento._id );
          arrayInf.splice(indexLis, 1);
        }
      })
    })

    arraySup.forEach((elemento, _id) => {
      if(elemento.estadoLis===false){
        arrayInf.push({_id: elemento._id, codigoTipoDoc: elemento.codigoTipoDoc,
          numeroDocum: elemento.numeroDocum, descrRecurso: elemento.descrRecurso, _idTipoRec: elemento._idTipoRec,
          descrTipoRec: elemento.descrTipoRec, areaAprovech: elemento.areaAprovech,
          estadoLis: false});
      }
    })
    
    arrayInf1 = arraySup.filter(item => item.estadoLis===false);
    arrayInf1.forEach((elemento1, _id) => {
      arraySup.forEach((elemento, _id) => {
        if(elemento.estadoLis===false && elemento1._id===elemento._id){
          const indexLis = arraySup.findIndex( servicio => servicio._id === elemento._id );
          arraySup.splice(indexLis, 1);
        }
      })
    })

    this.ordenarArrayAsc(arraySup, 'descrRecurso')
    this.ordenarArrayAsc(arrayInf, 'descrRecurso')

    this.setState({listSup: arraySup})
    this.setState({listInf: arrayInf})
    this.setState({open: false})
    this.setState({errors: []})
  }

  handleChange = (ev, elemento) => {
    if(ev.target.name === "estadoSup"){
      let listSup=this.state.listSup
      const indexLis = listSup.findIndex( recurso => recurso._id === ev.target.id );
      if(ev.target.name === "estadoSup"){
        if(elemento.estadoLis===false){
          listSup[indexLis].estadoLis = true
        }else{
          listSup[indexLis].estadoLis = false
        }
      }

      this.setState({listSup});
    }

    if(ev.target.name === "estadoInf"){
      let listInf=this.state.listInf
      const indexLis = listInf.findIndex( recurso => recurso._id === ev.target.id );
      if(elemento.estadoLis===false){
        listInf[indexLis].estadoLis = true
      }else{
        listInf[indexLis].estadoLis = false
      }
      this.setState({listInf});
    }
    // console.log(ev.target.name)

    if(ev.target.name === "fechaEjec"){
      let fechaEjec = this.state.fechaEjec
      fechaEjec = ev.target.value 
      this.setState({fechaEjec});
    }
    if(ev.target.name === "fechaFra"){
      let fechaFra = this.state.fechaFra
      fechaFra = ev.target.value 
      this.setState({fechaFra});
    }
    if(ev.target.name === "horaSolic"){
      let horaSolic = this.state.horaSolic
      horaSolic = ev.target.value 
      this.setState({horaSolic});
    }
    if(ev.target.name === "checkNoFactOsAb"){
      this.setState({checkNoFactOsAb: ev.target.checked});
    }  
  }
  
  render(){
    const {listInf, listSup, fechaEjec, fechaFra, horaSolic, checkNoFactOsAb} = this.state;

    const titulo = `${this.props.cliente.contrato} ${this.props.cliente.nombreCliente} ${this.props.cliente.apellidoCliente}`

    // console.log(argsDocum)
    // console.log(this.props.args)
    // console.log(this.props.cliente)
    // console.log(this.props.list)

    let fechaHoy = new Date()
    let fechaMin = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-01'
    let fechaMax = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
    fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    const numDM = getNumDiasMes(fechaHoy.substr(5, 2), fechaHoy.substr(0, 4))
    fechaMax += '-' + numDM
    
    let listServTar = [];

    let fechaV = document.getElementById("fechaEjec")
    fechaV?fechaV = fechaV.value:fechaV = fechaHoy
    let fechaF = document.getElementById("fechaFra")
    fechaF?fechaF = fechaF.value:fechaF = fechaHoy
    let estadoCi = ""

    let listServCargoFra = [];
    let nuevaRenta = 0;
    let listServOf = [];
    let listServOfNva = [];
    let listEquiCliAsig = [];
    let listEquiAsig = [];
    let argsBod = {}

    let pedirPtosAdic = ""
    let descrTipoOS = this.props.list, estadoCerrarOS = ""
    descrTipoOS = descrTipoOS.filter(elemento => elemento.descrTipoOS===this.props.args.descrTipoOS)
    if(descrTipoOS.length===1){
      estadoCerrarOS=descrTipoOS[0].estadoCerrarOS
      pedirPtosAdic=descrTipoOS[0].pedirPtosAdic
    }

    let lista1 = []
    if(this.props.args.descrTipoOS&&this.props.args.descrTipoOS!=="Seleccionar..."){
      lista1 = this.props.list1.filter(elemento => elemento.descrTipoOS===this.props.args.descrTipoOS)
    }

    let lista7 = ""
    if(this.props.list7.length>0){
      lista7 = "!ATENCION! Tiene en estado ABIERTA las siguientes OS: "
      for(let i=0; i<=this.props.list7.length-1; i++){
        lista7 += `${this.props.list7[i].numeroOS.toString()} (${this.props.list7[i].tipoos.descrTipoOS})`
        if(i<this.props.list7.length-1){
          lista7 += ", "
        }
      }
    }

    let updnoFactOSAb = false
    if((this.props.cliente.estadoCliente==='ACTIVO'&&(estadoCerrarOS==='DESCONECTADO, SUSPENDIDO o RETIRADO'||estadoCerrarOS==='DESCONECTADO'))){
      updnoFactOSAb = true
    }
    // console.log(checkNoFactOsAb, updnoFactOSAb)
    
    const a0101450101 = this.props.autorizacUA.findIndex( autorizac => autorizac === "0101450101" );
    // console.log(a0101450101, this.props.cliente.datosConfirmados, this.props.cliente)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          O de S nueva ={">"} {titulo}
        </button>
        <button name="btnRefr" id="btnRefr"  className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={this.handleRefresh}>
          <i className='large redo yellow icon'></i>
          Refrescar
        </button>

        <div style={this.props.styles.box}>
          <Form onSubmit={(ev)=>this.props.handleSubmit(ev, this.props.args, this.props.cliente,
              listSup, listServTar, listServOf, listEquiCliAsig, listEquiAsig, listServOfNva,
              this.props.list, fechaV, listServCargoFra, nuevaRenta, argsBod, estadoCi, fechaF,
              horaSolic, checkNoFactOsAb, updnoFactOSAb)}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  {
                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                  {
                    lista7?<Message negative size="big" header={lista7}/>:null
                  }

                  {/* <Form.Field>
                    <label style={this.props.styles.label}>Tipo</label>
                    <ListaTipo list={this.props.list} styles={this.props.styles} handleLista={this.props.handleLista} estado={this.props.cliente.estadoCliente}/>
                  </Form.Field> */}
                  <Form.Field>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={this.props.styles.boxGrid}>
                          <label style={this.props.styles.label}>Tipo</label>
                          <ListaTipo list={this.props.list} styles={this.props.styles} handleLista={this.props.handleLista} estado={this.props.cliente.estadoCliente}/>
                        </div>

                        {lista1.length>0 &&
                          <div className="column" style={this.props.styles.boxGrid}>
                            <label style={this.props.styles.label}>Categoría</label>
                            <ListaCateg list={lista1} styles={this.props.styles} handleLista={this.props.handleLista1}/>
                          </div>
                        }
                      </div>
                    </div>
                  </Form.Field>

                  {pedirPtosAdic==="SI" &&
                    <Form.Field>
                      <label style={this.props.styles.label}>Puntos Adicionales</label>
                      <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="ptosAdic" id="ptosAdic" placeholder='Puntos Adicionales' onChange={this.props.handleChange}/>
                    </Form.Field>
                  }

                  <Form.Field>
                    <label style={this.props.styles.label}>Observaciones</label>
                    <input style={this.props.styles.input} autoComplete="off" name="observacAB" id="observacAB" onChange={this.props.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observacAB'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>

                  <Form.Field>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={this.props.styles.boxGrid}>
                          <label style={this.props.styles.label}>Solicitante</label>
                          <input style={this.props.styles.input} autoComplete="off" name="nombreSolic"
                            id="nombreSolic" onChange={this.props.handleChange} placeholder='Solicitante'
                            icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nombreSolic'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                        </div>
                        <div className="column" style={this.props.styles.boxGrid}>
                          <label style={this.props.styles.label}>Hora de la solicitud</label>
                          <input style={this.props.styles.input}  type="time" min="00:00"
                            max="24:00" step="60" autoComplete="off" name="horaSolic" id="horaSolic"
                            value={horaSolic} onChange={this.handleChange}/>
                        </div>
                      </div>
                    </div>
                  </Form.Field>

                  <Form.Field>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={this.props.styles.boxGrid}>
                          <label style={this.props.styles.label}>Fecha de ejecución</label>
                          <input style={this.props.styles.input} type='date' name="fechaEjec" id="fechaEjec" value={fechaEjec?fechaEjec:fechaHoy} onChange={this.handleChange}/>
                        </div>
                        <div className="column" style={this.props.styles.boxGrid}>
                          <label style={this.props.styles.label}>Fecha inicio cargos / ofertas al cliente</label>
                          <input style={this.props.styles.input} type='date' name="fechaFra" id="fechaFra" value={fechaFra?fechaFra:fechaHoy} min={fechaMin} max={fechaMax} onChange={this.handleChange}/>
                        </div>
                      </div>
                    </div>
                  </Form.Field>
                  {(this.props.cliente.estadoCliente==='ACTIVO'&&(estadoCerrarOS==='DESCONECTADO, SUSPENDIDO o RETIRADO'||estadoCerrarOS==='DESCONECTADO')) &&
                    <Form.Field>
                      <p style={this.props.styles.label}>
                        <input style={{margin: '0.2em 0em 0em 0em'}} type='checkbox' name="checkNoFactOsAb" checked={checkNoFactOsAb}  onChange={this.handleChange}/>
                        &nbsp;&nbsp;NO FACTURAR MIENTRAS LA OS SE ENCUENTRE ABIERTA
                      </p>
                    </Form.Field>
                  }
                  
              {(a0101450101!==-1&&this.props.cliente.datosConfirmados==="NO") &&
                <div>
                  <hr></hr>
                  <div className="ui three column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '25%'}}>
                        <label style={this.props.styles.label}>Teléfono 1</label>
                        <Form.Field>
                          <input style={this.props.styles.input} pattern={"[0-9]{7,10}"}
                            autoComplete="off" name="telefono1" id="telefono1" value={this.props.args.telefono1?this.props.args.telefono1:!this.props.cliente.telefono1?'':this.props.cliente.telefono1}
                            onChange={this.props.handleChange}
                            placeholder='Teléfono 1'/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '40%'}}>
                        <label style={this.props.styles.label}>Correo electrónico</label>
                        <input style={this.props.styles.input} pattern={"[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\.[a-z]{0,}$"}
                          autoComplete="off" name="eMail" id="eMail" value={this.props.args.eMail?this.props.args.eMail:!this.props.cliente.eMail?'':this.props.cliente.eMail}
                          onChange={this.props.handleChange}
                          placeholder='Correo electrónico'/>
                      </div>
                      <div className="column" style={{width: '35%'}}>
                        <label style={this.props.styles.label}>Fecha de cumpleaños</label>
                        <Form.Field>
                          <input style={this.props.styles.input} type='date'
                            name="fechaCumple" id="fechaCumple" value={this.props.args.fechaCumple?this.props.args.fechaCumple:!this.props.cliente.fechaCumple?'':this.props.cliente.fechaCumple.substr(0, 10)}
                            onChange={this.props.handleChange}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <hr></hr>

                  <div className='ui blue inverted raised segment'>
                    <a href="#top" className='ui large label' style={this.props.styles.styTableSup}>Recursos asignados a la O de S</a>
                    <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                      <thead className=''>
                      <tr className=''>
                        <th className=''></th>
                        <th className=''>Doc</th>
                        <th className=''>Número</th>
                        <th className=''>Recurso</th>
                        <th className=''>Tipo de recurso</th>
                      </tr>
                      </thead>
                      <ListaSup list={listSup} handleChange={this.handleChange}/>
                    </table>
                  </div>
                  <div className='ui blue inverted raised segment'>
                    <a href="#top" className='ui large label' style={this.props.styles.styTableInf}>Recursos sin asignar a la O de S</a>
                    <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
                      <thead className=''>
                      <tr className=''>
                          <th className=''></th>
                          <th className=''>Doc</th>
                          <th className=''>Número</th>
                          <th className=''>Recurso</th>
                          <th className=''>Tipo de recurso</th>
                      </tr>
                      </thead>
                      <ListaInf list={listInf} handleChange={this.handleChange}/>
                    </table>
                  </div>

                  <Button style={this.props.styles.confirmar} type='submit' fluid>
                    AGREGAR
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default AddOS2
